import { render, staticRenderFns } from "./ProductPromotion1.vue?vue&type=template&id=45ae150d&scoped=true"
import script from "./ProductPromotion1.vue?vue&type=script&lang=js"
export * from "./ProductPromotion1.vue?vue&type=script&lang=js"
import style0 from "./ProductPromotion1.vue?vue&type=style&index=0&id=45ae150d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ae150d",
  null
  
)

export default component.exports